export default {
  name: 'OperationActionModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    setting: {
      default: () => ({}),
      type: Object,
    },
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
  },
};
